import mock from './mock';

const folder = {
  getDocFolder: {
    desc: '获取文件夹列表',
    method: 'get',
    url: 'api/v1/doc/folder/{id}',
    mock: false,
    request: { sort: '' },
    response: mock.getFolderList,
  },
  postDocFolder: {
    desc: '创建文件夹',
    method: 'post',
    url: 'api/v1/doc/folder',
    mock: false,
    request: { folder_name: '' },
    response: mock.createFolder,
  },
  putDocFolder: {
    desc: '修改文件夹名称',
    method: 'put',
    url: 'api/v1/doc/folder/{id}',
    mock: false,
    request: { folder_name: '' },
    response: mock.createFolder,
  },
  deleteDocFile: {
    desc: '删除文件',
    method: 'delete',
    url: 'api/v1/doc/file/{id}',
    mock: false,
    request: {},
  },
  deleteDocFolder: {
    desc: '删除文件夹',
    method: 'delete',
    url: 'api/v1/doc/folder/{id}',
    mock: false,
    request: {},
  },
  postDocPermission: {
    desc: '设置文件权限',
    method: 'post',
    url: '/api/v1/doc/permission',
    mock: false,
    request: {
      permissions: [],
    },
  },
  getDocPermission: {
    desc: '获取文件/文件夹权限',
    method: 'get',
    url: '/api/v1/doc/permission',
    mock: false,
    request: {
      file_ids: '',
      folder_ids: '',
    },
  },
  postDocFileChangeMail: {
    desc: '文件权限更新的邮件通知',
    method: 'post',
    url: '/api/v1/doc/file_change_mail',
    mock: false,
    request: {
      user_changed_files: [],
    },
  },
  getDocFile: {
    description: '下载文件',
    method: 'get',
    url: '/api/v1/doc/file/{id}',
    mock: false,
  },
  getDocFolderDownload: {
    description: '下载文件',
    method: 'get',
    url: '/api/v1/doc/folder/download/{id}',
    mock: false,
  },
  postDocFilesPassword: {
    description: '获取文件密码',
    method: 'post',
    url: '/api/v1/doc/files/password/{id}',
    mock: false,
  },
  searchDocFiles: {
    description: '文件（夹）搜索',
    method: 'get',
    url: '/api/v1/doc/search',
    mock: false,
  },
};

export default folder;
